import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { LoginType } from 'src/types/loginData';

interface GuestGuardProps {
  children: ReactNode;
  type: LoginType;
}

const GuestGuard = ({ children, type }: GuestGuardProps) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    if (type === LoginType.INSPECTOR) {
      return <Navigate to="/inspectorDT" />;
    }
    return <Navigate to="/" />;
  }
  return <>{children}</>;
};

export default GuestGuard;
